import { Theme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TOP_NAV_HEIGHTUpMd } from "../../_shared/Header";
import { ARTICLE_SECTION_OFFSET } from "../constants";

export const ArtcileSideBar = ({
  items,
  activeItemId,
}: {
  items: any[];
  activeItemId: string | null;
}) => {
  const { i18n, t } = useTranslation(["learningCenter"]);
  const downLg = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  const handleLinkClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    id: string
  ) => {
    event.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = TOP_NAV_HEIGHTUpMd + ARTICLE_SECTION_OFFSET;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const filteredItems = items.filter((item) => item.title !== "");

  return (
    <div
      className="article-sidebar"
      style={{
        direction: i18n.dir(),
        width: downLg ? "300px" : "364px",
      }}
    >
      <div className="article-sidebar-title">{t("table_of_contents")}</div>

      <ul>
        {filteredItems.map((item, index: number) => (
          <div key={index}>
            <div className="article-sidebar-line"></div>
            <li
              key={item.id}
              className={activeItemId === item.id ? "active-arctile" : ""}
            >
              <a
                href={`#${item.id}`}
                onClick={(e) => handleLinkClick(e, item.id)}
              >
                {item.title}
              </a>
            </li>
          </div>
        ))}
      </ul>
    </div>
  );
};
